import { apiClient } from './client'
import type { ApiResponse } from './client'
import type {
  IntegrationConnectionCreateDto,
  IntegrationConnectionSummaryDto,
  IntegrationConnectionWithKeyDto,
  IntegrationConnectionListResponse,
  IntegrationConnectionUpdateDto,
  IntegrationErrorSummaryDto,
  BigMarkerChannelDto
} from '@/types/integrations'

export const integrationsApi = {
  /** Company-admin only. For "is provider X connected", use getIntegrationSummary instead (ORB-699). */
  getIntegrationConnections: (clientCompanyId: string): Promise<ApiResponse<IntegrationConnectionListResponse>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations`),

  /** Which providers the workspace's company has connected, readable by any workspace member. */
  getIntegrationSummary: (workspaceId: string): Promise<ApiResponse<IntegrationConnectionSummaryDto[]>> =>
    apiClient.get(`/api/Workspaces/${workspaceId}/Integrations/Summaries`),

  createIntegrationConnection: (clientCompanyId: string, dto: IntegrationConnectionCreateDto): Promise<ApiResponse<IntegrationConnectionWithKeyDto>> =>
    apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations`, dto),

  updateIntegrationConnection: (clientCompanyId: string, id: string, dto: IntegrationConnectionUpdateDto): Promise<ApiResponse<null>> =>
    apiClient.put(`/api/ClientCompanies/${clientCompanyId}/Integrations/${id}`, dto),

  deleteIntegrationConnection: (clientCompanyId: string, id: string): Promise<ApiResponse<null>> =>
    apiClient.delete(`/api/ClientCompanies/${clientCompanyId}/Integrations/${id}`),

  resetIntegrationConnection: (clientCompanyId: string, id: string): Promise<ApiResponse<IntegrationConnectionWithKeyDto>> =>
    apiClient.post(`/api/ClientCompanies/${clientCompanyId}/Integrations/${id}/Reset`, {}),

  getIntegrationErrorSummary: (clientCompanyId: string, integrationId: string): Promise<ApiResponse<IntegrationErrorSummaryDto>> =>
    apiClient.get(`/api/ClientCompanies/${clientCompanyId}/Integrations/${integrationId}/ErrorSummary`),

  /** Channels the workspace's BigMarker account can publish to. Read live, so a retired channel stops being offered on its own. */
  getBigMarkerChannels: (workspaceId: string): Promise<ApiResponse<BigMarkerChannelDto[]>> =>
    apiClient.get(`/api/Workspaces/${workspaceId}/Integrations/BigMarker/Channels`),
}
